import { Form, Formik } from "formik";
import React from "react";
import InputField from "../../atoms/InputField";
import Button from "../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { UPDATE_USER } from "../../../api/apiAdmin";

const ModalEditProfile = ({ user, onClose }) => {
    const validate = (values) => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!values.email) { errors.email = "El email es requerido"; } 
            else if (!emailRegex.test(values.email)) { errors.email = "El email no es válido"; }
        return errors;
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const data = await UPDATE_USER(user.id, values);
            localStorage.setItem("user", JSON.stringify(data));
            window.location.reload();
            onClose();
        } catch (error) {
            toast.error("Error al actualizar");
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = { 
        email: user.email || "", 
        password: "", 
        name: user?.roleInfo?.name || "", 
        cellphone: user?.roleInfo?.cellphone  || "" ,
    };

    return(
        <div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validate={validate}>
				{({ isSubmitting }) => (
                    <Form className="w-full flex flex-col items-center justify-center text-center space-y-4">
                        <InputField name="name" label="Nombre completo" placeholder="Nombre completo" />
                        <InputField name="password" label="Nueva contraseña (opcional)" type="password" placeholder="Contraseña" />
						<InputField name="email" type="text" label=" Correo electrónico"placeholder="Nombre de usuario" />
						<InputField name="cellphone" label="Telefono" type="number" placeholder="telefono" />
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Iniciar sesión"} type="submit" bgColor="blue" disabled={isSubmitting}/>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ModalEditProfile;